import Vue from 'vue'

export const authDialogState = Vue.observable({
  visible: false,
  message: '',
  redirect: ''
})

export const showAuthDialog = (payload = {}) => {
  authDialogState.visible = true
  authDialogState.message = payload.message || '您的登录信息已过期，请重新登录后继续使用'
  authDialogState.redirect = payload.redirect || authDialogState.redirect || ''
}

export const hideAuthDialog = () => {
  authDialogState.visible = false
}

export const setAuthDialogRedirect = (redirect) => {
  authDialogState.redirect = redirect || ''
}
